import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ScrollbarModule } from 'ngx-scrollbar';
import { LsqCoreModule } from './core';
import { LsqFormsModule } from './forms';
import { LsqModalsModule } from './modals';
import { AsListSourcePipe } from './pipes/as-list-source.pipe';
import { CheckableRowsService } from './services/table/checkable-rows/checkable-rows.service';
import { CheckableRowsServiceFactory } from './services/table/checkable-rows/checkable-rows.service.factory';
import { ExpandableRowsService } from './services/table/expandable-rows/expandable-rows.service';
import { ExpandableRowsServiceFactory } from './services/table/expandable-rows/expandable-rows.service.factory';
import { LsqDataTableMobileComponent } from './table/components/data-table-mobile/lsq-data-table-mobile.component';
import { LsqDataTablePaginationComponent } from './table/components/data-table-pagination/lsq-data-table-pagination.component';
import { LsqDataTableStickyHeaderComponent } from './table/components/data-table/lsq-data-table-sticky-header';
import { LsqDataTableComponent } from './table/components/data-table/lsq-data-table.component';
import { LsqExpandableDataRowComponent } from './table/components/expandable-data-row/lsq-expandable-data-row.component';
import { LsqFilterBox } from './table/components/filter-box/lsq-filter-box.component';
import { LsqFilterControlComponent } from './table/components/filter-control/lsq-filter-control.component';
import { LsqDateFilterComponent } from './table/components/filters/date-filter/lsq-date-filter.component';
import { LsqEnumFilterComponent } from './table/components/filters/enum-filter/lsq-enum-filter.component';
import { LsqNumberFilterComponent } from './table/components/filters/number-filter/lsq-number-filter.component';
import { LsqTextFilterComponent } from './table/components/filters/text-filter/lsq-text-filter.component';
import {
    LsqGroupedDataTableComponent,
    TotalsRowKeyPair
} from './table/components/lsq-grouped-data-table/lsq-grouped-data-table.component';
import { LsqDataTableMobileCardComponent } from './table/components/mobile-table-card/data-table-mobile-card.component';
import { LsqMobileTableCardPaginationComponent } from './table/components/mobile-table-card/mobile-table-card-pagination/lsq-mobile-table-card-pagination.component';
import { NoDataComponent } from './table/components/no-data/no-data.component';
import { LsqPageInputComponent } from './table/components/page-input/lsq-page-input.component';
import { LsqSimplePaginationComponent } from './table/components/simple-pagination/lsq-simple-pagination.component';
import { StatusPillComponent } from './table/components/status-pill/status-pill.component';
import { LsqTableCheckboxControlsComponent } from './table/components/table-checkbox-controls/lsq-table-checkbox-controls.component';
import { LsqBaseColumnComponent } from './table/components/table-columns/base-column.component';
import { LsqButtonColumnComponent } from './table/components/table-columns/button-column.component';
import { LsqCheckboxColumnComponent } from './table/components/table-columns/checkbox-column.component';
import { LsqCurrencyColumnComponent } from './table/components/table-columns/currency-column.component';
import { CustomFooterCellDirective } from './table/components/table-columns/custom-cells/custom-cell-footer.directive';
import { CustomHeaderCellDirective } from './table/components/table-columns/custom-cells/custom-cell-header.directive';
import { CustomCellDirective } from './table/components/table-columns/custom-cells/custom-cell.directive';
import { LsqDateColumnComponent } from './table/components/table-columns/date-column.component';
import { LsqHiddenColumnComponent } from './table/components/table-columns/hidden-column.component';
import { LsqNumberColumnComponent } from './table/components/table-columns/number-column.component';
import { LsqPercentColumnComponent } from './table/components/table-columns/percent-column.component';
import { LsqPhoneNumberColumnComponent } from './table/components/table-columns/phone-number-column.component';
import { LsqRowCountColumnComponent } from './table/components/table-columns/row-count-column.component';
import { LsqSpacerColumnComponent } from './table/components/table-columns/spacer-column.component';
import { LsqStatusPillColumnComponent } from './table/components/table-columns/status-pill-column.component';
import { TableGroup } from './table/models/table-group';

export {
    CheckableRowsServiceFactory,
    CheckableRowsService,
    ExpandableRowsServiceFactory,
    ExpandableRowsService,
    LsqDataTableComponent,
    LsqDataTableStickyHeaderComponent,
    LsqDataTableMobileComponent,
    LsqFilterBox,
    LsqFilterControlComponent,
    LsqDateFilterComponent,
    LsqEnumFilterComponent,
    LsqNumberFilterComponent,
    LsqTextFilterComponent,
    LsqMobileTableCardPaginationComponent,
    LsqDataTableMobileCardComponent,
    LsqDataTablePaginationComponent,
    LsqPageInputComponent,
    NoDataComponent,
    LsqSimplePaginationComponent,
    LsqExpandableDataRowComponent,
    StatusPillComponent,
    LsqGroupedDataTableComponent,
    TotalsRowKeyPair,
    TableGroup,
    // Table Columns:
    LsqBaseColumnComponent,
    LsqRowCountColumnComponent,
    LsqCheckboxColumnComponent,
    LsqCurrencyColumnComponent,
    LsqSpacerColumnComponent,
    LsqButtonColumnComponent,
    LsqHiddenColumnComponent,
    LsqDateColumnComponent,
    LsqNumberColumnComponent,
    LsqPercentColumnComponent,
    LsqStatusPillColumnComponent,
    LsqPhoneNumberColumnComponent,
    AsListSourcePipe,
    LsqTableCheckboxControlsComponent,
    CustomFooterCellDirective,
    CustomCellDirective,
    CustomHeaderCellDirective
};

@NgModule({
    imports: [
        LsqCoreModule.forChild(),
        LsqModalsModule,
        LsqFormsModule,
        CommonModule,
        ScrollbarModule,
        CdkTableModule
    ],
    declarations: [
        CustomFooterCellDirective,
        CustomCellDirective,
        CustomHeaderCellDirective,
        LsqDataTableComponent,
        LsqDataTableStickyHeaderComponent,
        LsqDataTableMobileComponent,
        LsqFilterControlComponent,
        LsqDateFilterComponent,
        LsqEnumFilterComponent,
        LsqNumberFilterComponent,
        LsqTextFilterComponent,
        LsqMobileTableCardPaginationComponent,
        LsqDataTableMobileCardComponent,
        LsqDataTablePaginationComponent,
        LsqPageInputComponent,
        NoDataComponent,
        LsqSimplePaginationComponent,
        StatusPillComponent,
        LsqRowCountColumnComponent,
        LsqCheckboxColumnComponent,
        LsqCurrencyColumnComponent,
        LsqSpacerColumnComponent,
        LsqButtonColumnComponent,
        LsqHiddenColumnComponent,
        LsqDateColumnComponent,
        LsqNumberColumnComponent,
        LsqPercentColumnComponent,
        LsqStatusPillColumnComponent,
        LsqPhoneNumberColumnComponent,
        LsqBaseColumnComponent,
        LsqFilterBox,
        AsListSourcePipe,
        LsqTableCheckboxControlsComponent
    ],
    exports: [
        CustomFooterCellDirective,
        CustomCellDirective,
        CustomHeaderCellDirective,
        LsqCoreModule,
        LsqModalsModule,
        LsqFormsModule,
        CdkTableModule,
        LsqDataTableComponent,
        LsqDataTableStickyHeaderComponent,
        LsqDataTableMobileComponent,
        LsqDataTablePaginationComponent,
        LsqFilterControlComponent,
        LsqDateFilterComponent,
        LsqEnumFilterComponent,
        LsqNumberFilterComponent,
        LsqTextFilterComponent,
        LsqMobileTableCardPaginationComponent,
        LsqDataTableMobileCardComponent,
        LsqPageInputComponent,
        NoDataComponent,
        LsqSimplePaginationComponent,
        LsqRowCountColumnComponent,
        StatusPillComponent,
        LsqCheckboxColumnComponent,
        LsqCurrencyColumnComponent,
        LsqNumberColumnComponent,
        LsqSpacerColumnComponent,
        LsqButtonColumnComponent,
        LsqHiddenColumnComponent,
        LsqDateColumnComponent,
        LsqPercentColumnComponent,
        LsqStatusPillColumnComponent,
        LsqPhoneNumberColumnComponent,
        LsqBaseColumnComponent,
        LsqFilterBox,
        AsListSourcePipe,
        LsqTableCheckboxControlsComponent
    ]
})
export class LsqTablesModule {
    public static forRoot(): ModuleWithProviders<LsqTablesModule> {
        console.debug('Loading libs/LsqTablesModule.forRoot.');
        return {
            ngModule: LsqTablesModule,
            providers: [CheckableRowsServiceFactory, ExpandableRowsServiceFactory, AsListSourcePipe]
        };
    }

    public static forChild(): ModuleWithProviders<LsqTablesModule> {
        console.debug('Loading libs/LsqTablesModule.forChild.');
        return {
            ngModule: LsqTablesModule
        };
    }
}
